<template>
  <div class="input-container">
    <legend>{{ legend }}</legend>

    <div class="input-content">
      <InputDate :modelValue="firstModelValue" @update:modelValue="$emit('update:firstModelValue', $event)"
        :disabled="disabled" />
      <ArrowRightThin :size="18" />
      <InputDate :modelValue="secondModelValue" @update:modelValue="$emit('update:secondModelValue', $event)"
        :disabled="disabled" />
    </div>
  </div>
</template>

<script>
import InputDate from './InputDate.vue'
import ArrowRightThin from 'icons/ArrowRightThin'

export default {
  name: 'Period',
  components: {
    InputDate,
    ArrowRightThin,
  },
  props: {
    legend: {
      type: String,
      required: true,
    },
    firstModelValue: {
      type: String,
      required: true,
    },
    secondModelValue: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  legend {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: #606264;
    line-height: 21.82px;
  }

  .input-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.4375rem;

    span {
      color: #000;
    }

    input {
      flex: 1;
    }
  }
}
</style>